import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Table } from "antd";
import routerConstant from "service/constant/routerConstant";
import moment from "moment";

interface Props {
  data: any;
  selectTable: string[];
  setSelectTable: React.Dispatch<React.SetStateAction<string[]>>;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  limit: number;
}

const CustomTable = styled(Table)`
  .ant-table-thead > tr > th {
    color: #6b7280;
    font-size: 12px;
    font-weight: 600;
  }
  .ant-table-tbody > tr > td {
    color: #111827;
    font-size: 14px;
  }
  .routerBtn {
    font-weight: 400;
    text-decoration: underline;
    cursor: pointer;
  }
`;

export function LectureTable({
  data,
  selectTable,
  setSelectTable,
  page,
  setPage,
  limit,
}: Props) {
  const navigate = useNavigate();

  const handleDetailBtn = (id: string) => {
    navigate(`${routerConstant.contents.lecture}/${id}`);
  };

  const columns = [
    {
      title: "NO",
      dataIndex: "id",
    },
    {
      title: "강의ID",
      dataIndex: "LectureId",
    },
    {
      title: "카테고리",
      dataIndex: "Category",
      render: (category: any) => <>{category?.name}</>,
    },
    {
      title: "강의명",
      dataIndex: "title",
    },
    {
      title: "강사명",
      dataIndex: "teacher",
    },
    {
      title: "강의 개설일",
      dataIndex: "createdAt",
      render: (text: string) => <>{moment(text).format("YYYY.MM.DD")}</>,
    },
    {
      title: "공개여부",
      dataIndex: "status",
      render: (status: boolean) => <>{status ? "공개" : "비공개"}</>,
    },
    {
      title: "상세보기",
      dataIndex: "id",
      render: (text: number) => (
        <span className="routerBtn" onClick={() => handleDetailBtn(text + "")}>
          바로가기
        </span>
      ),
    },
  ];

  const handleSelectTableChange = (selectTable: any) => {
    setSelectTable(selectTable);
  };

  const rowSelection: any = {
    selectedRowKeys: selectTable,
    onChange: handleSelectTableChange,
  };

  return (
    <CustomTable
      rowKey="id"
      rowSelection={rowSelection}
      dataSource={data.data}
      columns={columns}
      pagination={{
        current: page,
        pageSize: limit,
        onChange: (page) => setPage(page),
        total: data.count,
        showSizeChanger: false,
      }}
    />
  );
}
